<template>

  <div class="card mb-3">
    <div class="card-body">
      <div class="form-group mb-3">
        <label>{{ $t('Subject') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="formData.subject">
      </div>
      <div class="form-group mb-3">
        <textarea-editable
          v-model="formData.body"
          :variables="['[candidate_full_name]', '[candidate_first_name]', '[job_title]', '[company_name]', '[member_full_name]', '[member_first_name]']"
          editor-model="html"
          :enable-link="false"
          :enable-img="true">
          <!--'[job_link]' recursos funcionando mas desabilitado temporariamente para verificar se realmente vale a pena-->
          </textarea-editable>
      </div>

      <div
        v-for="(question, question_index) in formData.questions"
        :key="question_index">
        <div class="d-flex align-items-center">
          <input
            type="text" 
            class="form-control" 
            :placeholder="$t('Question')"
            v-model="question.text">
          <a href="javascript:void(0)"
            class="text-secondary py-1 px-2"
            @click="removeQuestion(question_index)">
            <i class="fa-solid fa-xmark"></i>
          </a>
        </div>
      </div>
      <button
        v-if="this.formData.questions.length < 12"
        type="button"
        class="btn btn-link"
        @click="addQuestion">
        {{ $t('Add question') }}
      </button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ScoreformInterviewForm',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formData: {
        instruction: '',
        questions: []
      }
    }
  },
  computed: {
  },
  watch: {
    value: {
      handler (val) {
        if (JSON.stringify(this.formData) !== JSON.stringify(val)) {
          this.formData = {
            ...val,
            questions: val.questions || []
          }
        }
      },
      deep: true,
      immediate: true
    },
    formData: {
      handler (val) {
        if (JSON.stringify(this.value) !== JSON.stringify(val)) {
          this.$emit('input', val)
        }
      },
      deep: true
    }
  },
  mounted () {
  },
  methods: {
    removeQuestion (index) {
      if (this.formData.questions) {
        this.formData.questions.splice(index, 1)
      }
    },
    addQuestion () {
      if (this.formData.questions) {
        this.formData.questions.push({ text: '' })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Scoreform/ScoreformVoiceInterviewForm.vue